import { EVENT_KEY, TRACKING_INTERACTION } from 'src/config/tracking/index.js'
import trackingUtils from 'src/config/services/countlyTracking/utils.js'
import { DISCOVERY_FEATURES } from 'src/config/constants.ts'

const appTracking = {
  trackApp () {
    const interaction = {
      openAppSwitcher: () => trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'app-switcher', interaction: TRACKING_INTERACTION.OPEN }),
      appFeatureClick: ({ featureId }) => trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'app-switcher', interaction: TRACKING_INTERACTION.CLICK_APP_SWITCHER, appFeature: featureId }),
      appMoreClick: ({ productName }) => trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'app-switcher', interaction: TRACKING_INTERACTION.CLICK_APP_SWITCHER, more: productName }),
      mainMenuClick: () => trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'main-menu', interaction: TRACKING_INTERACTION.CLICK_MAIN_MENU }),
      customLinkClick: () => trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'more', interaction: TRACKING_INTERACTION.CLICK_CUSTOM_LINK }),
      toggleTutorial: ({ show, tutorial, ...rest }) => {
        return trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'tutorial', interaction: show ? TRACKING_INTERACTION.CLICK_TUTORIAL : TRACKING_INTERACTION.HIDE_TUTORIAL, tutorial, ...rest })
      },
      moreItemClick: ({ item }) => {
        const option = {
          administration: TRACKING_INTERACTION.CLICK_ADMINISTRATION,
          sduiPlanner: TRACKING_INTERACTION.CLICK_SDUI_PLANNER,
          calendar: TRACKING_INTERACTION.CLICK_CALENDAR,
          absenceManagement: TRACKING_INTERACTION.CLICK_ABSENCE_MANAGEMENT,
          cloud: TRACKING_INTERACTION.CLICK_CLOUD,
          authenticator: TRACKING_INTERACTION.CLICK_AUTHENTICATOR,
          classbook: TRACKING_INTERACTION.CLICK_CLASS_REGISTER,
          sduiAcademy: TRACKING_INTERACTION.CLICK_SDUI_ACADEMY,
          fujitsu: TRACKING_INTERACTION.CLICK_FUJITSU,
          sduiPlus: TRACKING_INTERACTION.CLICK_SDUI_PLUS,
          roomBooking: TRACKING_INTERACTION.CLICK_ROOM_BOOKING,
          daycare: TRACKING_INTERACTION.CLICK_DAYCARE,
          mediaLibrary: TRACKING_INTERACTION.CLICK_MEDIA_LIBRARY,
          meetingProtocols: TRACKING_INTERACTION.CLICK_MEETING_PROTOCOLS,
          inventory: TRACKING_INTERACTION.CLICK_INVENTORY,
          parentMeetings: TRACKING_INTERACTION.CLICK_PARENT_MEETINGS,
          socialManagement: TRACKING_INTERACTION.CLICK_SOCIAL_MANAGEMENT,
          aiChat: TRACKING_INTERACTION.CLICK_AI_CHAT,
          aiAssistant: TRACKING_INTERACTION.CLICK_AI_ASSISTANT,
          gradesAndCertifications: TRACKING_INTERACTION.CLICK_GRADES_AND_CERTIFICATIONS
        }
        const interaction = option[item]
        if (!interaction) {
          console.warn(`Unknown item for more tracking: ${item}`)
          return
        }
        return trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'more', interaction })
      },
      discoveryFeatureClick: ({ feature }) => {
        const validFeatures = Object.keys(DISCOVERY_FEATURES)
        if (!validFeatures.includes(feature)) {
          console.warn(`Unknown feature for discovery tracking: ${feature}`)
          return
        }
        return trackingUtils.track(EVENT_KEY.APP.INTERACTION, { feature: 'discovery', interaction: TRACKING_INTERACTION[`CLICK_${feature}`] })
      }
    }
    return { interaction }
  }
}

export default appTracking
